
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');

        if (!mediaId) {
          console.warn('ProductModal: missing data-media-id');
          return;
        }

        const mediaElements = this.querySelectorAll('[data-media-id]');

        const activeMedia = Array.from(mediaElements).find(
          (element) => element.getAttribute('data-media-id') === mediaId
        );

        if (!activeMedia) {
          console.warn(
            'ProductModal: media not found in modal:',
            mediaId
          );
          return;
        }

        mediaElements.forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        activeMedia.scrollIntoView({
          block: 'nearest',
          inline: 'center'
        });

        const container = this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft =
            (activeMedia.getBoundingClientRect().width -
              container.clientWidth) / 2;
        }

        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          const template = activeMedia.querySelector('template');

          if (template?.content.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}
